var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-page", attrs: { role: "main" } },
    [
      _vm.isCurrentRoleEmployee
        ? _c("dash-board-employee-component", {
            staticClass: "container dashboard-page__content",
          })
        : _vm._e(),
      _vm.isCurrentRoleResponsible
        ? _c("dash-board-responsible-component", {
            staticClass: "dashboard-page__content",
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }